/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFrontLoaderIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-front-loader"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.75 20.32Q2.38 20.32 1.4 19.35Q0.42 18.38 0.42 17L0.42 10.5Q0.42 9.55 1.11 8.86Q1.8 8.18 2.75 8.18L7.42 8.18L7.42 4.5Q7.42 3.95 7.81 3.56Q8.2 3.17 8.75 3.17L12.75 3.17Q14.13 3.17 15.1 4.15Q16.07 5.13 16.07 6.5L16.07 9.88L17.07 9.88L17.07 9.35Q17.07 8.9 17.25 8.47Q17.43 8.05 17.75 7.72L18.7 6.78Q19.18 6.3 19.84 6.39Q20.5 6.47 20.82 7.08L23.9 12.9Q24.25 13.55 23.88 14.2Q23.5 14.85 22.73 14.85L19.4 14.85Q18.45 14.85 17.76 14.16Q17.07 13.47 17.07 12.53L17.07 12.53L16.07 12.53L16.07 14.65Q16.55 15.13 16.81 15.74Q17.07 16.35 17.07 17Q17.07 18.38 16.1 19.35Q15.13 20.32 13.75 20.32Q12.75 20.32 11.93 19.79Q11.1 19.25 10.7 18.35L6.78 18.35Q6.38 19.25 5.55 19.79Q4.72 20.32 3.75 20.32ZM3.75 17.68Q4.03 17.68 4.22 17.48Q4.42 17.27 4.42 17Q4.42 16.73 4.22 16.52Q4.03 16.32 3.75 16.32Q3.48 16.32 3.27 16.52Q3.08 16.73 3.08 17Q3.08 17.27 3.27 17.48Q3.48 17.68 3.75 17.68ZM13.75 17.68Q13.75 17.68 13.89 17.68Q14.03 17.68 14.22 17.48Q14.43 17.27 14.43 17Q14.43 16.73 14.22 16.52Q14.03 16.32 13.75 16.32Q13.47 16.32 13.28 16.52Q13.07 16.73 13.07 17Q13.07 17.27 13.28 17.48Q13.47 17.68 13.75 17.68ZM20.55 12.2L19.73 10.68L19.73 10.68Q19.73 10.68 19.73 10.68Q19.73 10.68 19.73 10.68L19.73 12.2Q19.73 12.2 19.73 12.2Q19.73 12.2 19.73 12.2ZM10.07 9.88L13.43 9.88L13.43 6.5Q13.43 6.22 13.22 6.03Q13.03 5.83 12.75 5.83L10.07 5.83Z" fill={color} />
    </svg>
  );
}
